import React from 'react';
import { appendClassName } from '../../../lib/bemUtils/classname';
import bem from '../../../lib/bemUtils/bem';
import { LiProps } from '../../../types/HtmlProps';
import { Modifier } from '../../../lib/bemUtils/Modifier';

export enum ImageListItemModifier {
  DRAGGING = 'dragging',
}

export type ImageListItemProps = LiProps & {
  modifier?: Modifier<ImageListItemModifier>;
  ref?: React.RefObject<HTMLLIElement>;
};

export function ImageListItem({ children, modifier, className, ref, ...props }: ImageListItemProps) {
  return (
    <li className={appendClassName(className, bem('image-gallery__list-item', modifier))} {...props} ref={ref}>
      <div className="image-gallery__image-container">{children}</div>
    </li>
  );
}
